/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumera los campos que pueden editarse de una reserva.
 */
export type KoguiReservaPatchFieldsEnum = 'addMovimientos' | 'personas' | 'comentario';

export const KoguiReservaPatchFieldsEnum = {
    AddMovimientos: 'addMovimientos' as KoguiReservaPatchFieldsEnum,
    Personas: 'personas' as KoguiReservaPatchFieldsEnum,
    Comentario: 'comentario' as KoguiReservaPatchFieldsEnum
};

